import { NotificationHeaderType } from '@enums/NotificationType';
import { FC, useEffect } from 'react';
import styled from 'styled-components';
import { NotificationResource } from '../../../types/NotificationResource';
import NotificationListItem from '../notification-list-item/NotificationListItem';
import { ListItem } from '../SharedNotificationStyles';

export type NotificationListProps = {
  notifications?: NotificationResource[];
  isEssentialType: boolean;
  onClick: (item: NotificationResource) => void;
  onRead: (item: NotificationResource) => void;
  windowHeight: number;
  filteredItems: NotificationResource[];
  activeFilter?: NotificationHeaderType;
};

const NotificationList: FC<NotificationListProps> = (props) => {
  useEffect(() => {
    const handleLinkClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A') {
        e.stopPropagation();
      }
    };

    if (props.activeFilter === 'WebsiteActivity') {
      const container = document.getElementById('notifications-wrapper');
      container?.addEventListener('click', handleLinkClick);
      return () => container?.removeEventListener('click', handleLinkClick);
    }
  }, [props.activeFilter]);

  return (
    <Wrapper
      $maxHeight={props.windowHeight - 193}
      data-testid='notification-list'
      id='notifications-wrapper'
    >
      {props.notifications &&
        props.notifications.length > 0 &&
        props.notifications.map((row: NotificationResource) => {
          return (
            <NotificationListItem
              key={row.id}
              item={row}
              isEssentialType={props.isEssentialType}
              onClick={props.onClick}
              onRead={props.onRead}
            />
          );
        })}
      {props.filteredItems && props.filteredItems.length === 0 && (
        <ListItem className='empty'>
          <p className='text-center'>No items in this category</p>
        </ListItem>
      )}

      {props.filteredItems &&
        props.filteredItems.length > 0 &&
        props.notifications &&
        props.notifications.length === 0 && (
          <ListItem className='empty'>
            <p className='text-center'>
              Only read items in this category ({props.filteredItems.length})
            </p>
          </ListItem>
        )}
    </Wrapper>
  );
};

type WrapperProps = {
  $maxHeight: number;
};

const Wrapper = styled.ul<WrapperProps>`
  max-height: ${(props) => props.$maxHeight + `px`};
  padding: 0;
  overflow-y: auto;
`;

export default NotificationList;
